import { render, staticRenderFns } from "./tournamentMapping.vue?vue&type=template&id=55dfd2af"
import script from "./tournamentMapping.vue?vue&type=script&lang=js"
export * from "./tournamentMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports